module.exports = __webpack_public_path__ + "img/taketomi_5.76a7f107.jpg";